export const PurpleRectangle = () => {
  return (
    <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9998 2.50027L4.49158 21.1164" stroke="#8854F8" stroke-width="8.65463" />
    </svg>
  );
};
